import { useEffect, useState } from 'react';
import { fromJS, List } from 'immutable';
import { filter } from 'lodash';
import piction from '../../../utils/piction';
import appConfig from '../../../appConfig';

const options = {
  RETURN_COLOUR: 'TRUE',
  RETURN_COLLECTION_DETAILS: 'TRUE',
  DEPTH: 2,
  READ_ONLY_CHECK: 'TRUE',
};
export function useRootCategory() {
  if (appConfig.categoriesSortByCC) options.SORT_ON = 'IGNORE';
  const [rootCategory, setRootCategory] = useState([]);
  const [isRetrievingRoot, setIsRetrievingRoot] = useState(true);
  useEffect(() => {
    piction.getCategories(null, options)
      .then((res) => {
        if (res.RETURN_MESSAGE || res.RETURN_MESSAGE === 'Unable to verify credentials') {
          throw new Error(res.RETURN_MESSAGE);
        }
        // remove the lightboxes from the category list
        let processedCategoryList;

        if (res.ct) { // normal categories have been returned
          processedCategoryList = fromJS(
            filter(res.res.ct, data => data.t !== 'L')
          );
        } else if (res.res.cl) { // categories returned with collections
          processedCategoryList = fromJS(
            filter(res.res.cl, data => data.t !== 'LX')
          );
        }
        setRootCategory(processedCategoryList);
        setIsRetrievingRoot(false);
      })
      .catch((err) => {
        setRootCategory(new List());
        setIsRetrievingRoot(false);
        console.log(err);
      });
  }, []);

  return [isRetrievingRoot, rootCategory];
}
